import React, { useEffect, useState } from 'react';
import { formatLongDateTime } from './util';
import { labels } from './labels';

const AppointmentInfo = ({ appt, apptType }) => {
    return (<>
        <h2 className="mb-3">Appointment Information</h2>
        {/*<p>{labels.personalinfo.details}</p>*/}
        <div className="row">
            {appt.photo &&
                <div className="col-auto">
                <img src={(window as any).PHOTO_URL + appt.photo} alt={appt.firstName + " " + appt.lastName} style={{ width: "100px" }} />
                </div>
            }
            <div className="col">
                <div className="apptInfo">
                    <p><strong>Provider</strong>: {appt.firstName} {appt.lastName}{appt.academicTitle && (", " + appt.academicTitle)}</p>
                    <p><strong>Time</strong>: {formatLongDateTime(new Date(appt.startTime))}</p>
                    <p><strong>Location</strong>: {appt.virtualist ? <b>Virtual Primary Care</b> : appt.clinic}
                        {!appt.virtualist && <>&nbsp;<span className="badge rounded-pill bg-secondary text-light">In Person</span></>}
                    </p>
                </div>
            </div>
        </div>
    </>);
}

export default AppointmentInfo;